import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './header'
import { Footer } from './footer'
import { AnchorTop, Icon } from '@ztechapps/webui.util'

export default function Layout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      <AnchorTop icon={<Icon type={'bi'} name="arrow-up" />} />
    </>
  )
}
